import { CUser, IUser } from '@ts/ui-models';
import { createUseFetchByIdHook } from './useFetchByIdFactory';
import { getUsers } from '@services/DataBase/Users.service';

//@ts-ignore
const useFetchUser = createUseFetchByIdHook<IUser, CUser>({
    selector: state => state.global.usersList,
    key: 'usersList',
    fetchFn: (dispatch, ids) => getUsers(dispatch, ids),
    mapToClass: (model) => new CUser(model),
});

export default useFetchUser